import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { VisualisationType } from '@modules/quantify/store/types';
import { getDeltaClause, getGroupBy } from '@modules/quantify/utils';
import { useTaxonomyStore } from '@modules/taxonomy/store/taxonomyStore';
import { EQLProps, ExpressionType } from 'v2/core/repository/eql/types';
import { useGetUser } from 'v2/core/services/user';

export const useGetQuantifyBaseEQLProps = (): Omit<
  EQLProps,
  'sourceDetailsMap'
> => {
  const {
    tenant: { timezone },
  } = useGetUser();
  const taxonomyID = useTaxonomyStore(({ taxonomyID }) => taxonomyID ?? '');
  const duration = useQuantifyStore(({ query }) => query.duration);
  const groupBy = useQuantifyStore(({ query }) => query.groupBy);
  const metadata = useQuantifyStore(({ metadata }) => metadata);
  const whereClause = useQuantifyStore(
    ({ query }) => query.whereClauseConfig?.whereClause || undefined,
  );
  const compareTo = useQuantifyStore(({ query }) => query.compareTo);

  const dateRange = duration as EQLProps['dateRange'];

  const getAggregatePeriod = () => {
    if (metadata.activeVisualisationType === VisualisationType.TREND) {
      return metadata.aggregatePeriod;
    }

    return undefined;
  };

  return {
    timezone,
    taxonomyID,
    dateRange,
    whereClause,
    expressionType: ExpressionType.Aggregates,
    groupBy: getGroupBy(groupBy, metadata),
    aggregatePeriod: getAggregatePeriod(),
    delta: getDeltaClause(compareTo, duration),
  };
};
